import { Text } from '@theneatcompany/nui'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Link from '@/components/common/Link'
import { COMPANY_NAME, URLS } from '@/constants'
import { getMessage } from '@/utils/messages'

import styles from './Copyright.module.scss'

const Copyright = ({ className = '' }) => (
  <div className={cx(styles.block, className)}>
    <div className={styles.text}>
      <Text size="tiny" color="foreground-secondary">
        {getMessage('login.copyright.yearAndName', { companyName: COMPANY_NAME })}
      </Text>
      &nbsp;
      <Text size="tiny" color="foreground-secondary">
        {getMessage('login.copyright.rightsReserved')}
      </Text>
    </div>
    <div>
      <Link to={URLS.termsAndConditions} external openTab size="tiny">
        {getMessage('login.termsAndConditions')}
      </Link>
      <Link to={URLS.privacyPolicy} external openTab size="tiny">
        {getMessage('login.privacyPolicy')}
      </Link>
    </div>
  </div>
)

Copyright.propTypes = {
  className: PropTypes.string,
}

export default Copyright
